export const userTrackingState = {
  GA: 'googleAnalytics',
  HOTJAR: 'hotjar',
  NONE: null,
}

export const USER_TRACKING_KEY = 'userTracking'
